import { render, staticRenderFns } from "./External.vue?vue&type=template&id=fe3c0936&scoped=true"
import script from "./External.vue?vue&type=script&lang=js"
export * from "./External.vue?vue&type=script&lang=js"
import style0 from "./External.vue?vue&type=style&index=0&id=fe3c0936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3c0936",
  null
  
)

export default component.exports